import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import {
    FundableClientsStat,
    PayableClaimsProgress,
    SectionVisibilityGroup,
    IntroducerClientActions,
} from '../components/reusable'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { StatsView } from '../components/views'

import globalStyles from '../globals/pages.module.scss'
import Modal from '../components/reusable/modal'
import { ViewChartDataModalContent } from '../components/modalContent/viewChartDataContent'
import { Page, PageHeader } from '../ui'

interface selectObjectProps {
    value: string
    label: string
}

function AdlHome() {
    const navigate = useNavigate()
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)
    const [overviewData, setOverviewData] = useState<any>()
    const [modalChartData, setModalChartData] = useState<any>()
    const [modalState, setModalState] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalDate, setModalDate] = useState('')

    useEffect(() => {
        if (modalChartData != null) {
            setModalState(true)
        }
    }, [modalChartData])

    useEffect(() => {
        if (!dataReady && !loading) {
            setLoading(true)
            getData()
        }
    }, [dataReady, loading])

    const getData = async () => {
        Loading.circle('Loading...')
        try {
            const apiResponse = await api({ url: '/all-day-loans' })
            const data = apiResponse.data
            // console.log('SYSTEM OVERVIEW DATA: ', data)
            setOverviewData(data)
            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response.status == 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else {
                window.location.href = getLoginUrl()
            }
        }
    }

    const prepChartData = (data: any) => {
        setModalDate(data.date)
        setModalChartData(data.dataResults)
        setModalTitle(data.title)
        // setModalState(false)
    }

    const toggleModal = () => {
        setModalChartData(null)
        setModalTitle('')
        setModalState(false)
    }
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="PCP Introducers" title={'All Day Loans Lead Tracker'} />
                    <SectionVisibilityGroup audience="introducer" introducer="All Day Loans">
                        {dataReady ? (
                            <StatsView
                                stats={overviewData.stats}
                                chartData={overviewData?.chartData}
                                dataGroup={overviewData.group}
                                handleDataModal={prepChartData}
                                excludeTitles={['Claims Progress']}
                            />
                        ) : (
                            <></>
                        )}
                    </SectionVisibilityGroup>
                    <SectionVisibilityGroup audience="admin" introducer="All Day Loans">
                        {/* ADL doesn't operate on the payable/fundable criteria, so these
                            stay admin-only. Their API routes are also not whitelisted for
                            the ADL org (see case-delivery-app authorisedRoutes.js), so
                            showing them to ADL users would just produce 401s. */}
                        <PayableClaimsProgress introducer="ADL" />
                        <FundableClientsStat introducer="ADL" />
                        {dataReady ? (
                            <StatsView
                                stats={overviewData.stats}
                                chartData={overviewData?.chartData}
                                dataGroup={overviewData.group}
                                handleDataModal={prepChartData}
                                onlyTitles={['Claims Progress']}
                            />
                        ) : (
                            <></>
                        )}
                        <IntroducerClientActions introducer="ADL" introducerLabel="ADL" />
                    </SectionVisibilityGroup>
                </Page>
            </MainView>

            <Modal modalState={modalState} previewModalAction={toggleModal}>
                <ViewChartDataModalContent
                    chartData={modalChartData}
                    closeModal={toggleModal}
                    chartTitle={modalTitle}
                    chartDate={modalDate}
                />
            </Modal>
        </div>
    )
}

export default AdlHome
